import { render, staticRenderFns } from "./NewsAddNew.vue?vue&type=template&id=0c1df8ea&scoped=true"
import script from "./NewsAddNew.vue?vue&type=script&lang=ts"
export * from "./NewsAddNew.vue?vue&type=script&lang=ts"
import style0 from "./NewsAddNew.vue?vue&type=style&index=0&id=0c1df8ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c1df8ea",
  null
  
)

export default component.exports